import type { Facts } from "../checks/buildFacts";

export function canShowInnerDeactivate(facts: Facts): boolean {
  if (facts.role === "Contributor") {
    return facts.submittedBySameUser && !facts.isApproved;
  }
  return false;
}
